import { configureStore } from '@reduxjs/toolkit';
import translationReducer from '../../../../common/lib/redux/slices/translationSlice';

export const store = configureStore({
  reducer: {
    translations: translationReducer,
  },
});

export type SPSSPAState = ReturnType<typeof store.getState>;
export type SPSSPADispatch = typeof store.dispatch;

export default store;
